import './compliance-rules.scss'

import { Card, Tabs, Typography } from 'antd'
import React, { useState } from 'react'
import { Column } from 'react-display-flex'

import { SelectTenant } from '../../../components'
import { IssuerComplianceRules } from './Issuer'
import { MaturityComplianceRules } from './Maturity'
import { RatingComplianceRules } from './Rating'

const { TabPane } = Tabs

export const CompliancesRules = () => {
  const [currentTenant, setCurrentTenant] = useState(null)

  return (
    <Column className="compliances">
      <Typography.Title>Compliance Rules</Typography.Title>

      <SelectTenant onTenantSelected={setCurrentTenant} />

      {!currentTenant ? (
        <Card>
          <Typography.Title level={3}>Select a tenant</Typography.Title>
          <Typography>Please select a tenant to check its compliances rules</Typography>
        </Card>
      ) : (
        <Tabs defaultActiveKey="counterpartyCompliances" type="card">
          <TabPane tab="Counterparty Compliances" key="counterpartyCompliances">
            <IssuerComplianceRules tenant={currentTenant} />
          </TabPane>
          <TabPane tab="Maturity Compliances" key="maturityCompliances">
            <MaturityComplianceRules tenant={currentTenant} />
          </TabPane>
          <TabPane tab="Rating Compliances" key="ratingCompliances">
            <RatingComplianceRules tenant={currentTenant} />
          </TabPane>
        </Tabs>
      )}
    </Column>
  )
}
